import { useEffect, useState } from "react";
import { Loading } from "../../Loading/Index";
import { parseUtcDate } from "../../../utils/date/formatedDate";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/icons/rightChevron.svg";
import { ReactComponent as InfoIcon } from "../../../assets/svg/icons/info.svg";
import { useTableMonitor } from "../../../hooks/useTableMonitor";
import ViewTasks from "../../Tasks/ViewTasks";
import "../TaskEvaluation/styles.css";

type NotificationTableProps = {
  listTable: ITaskNotification[];
  isLoading: boolean;
};

type Column = {
  key: string;
  label: string | JSX.Element;
};

const columns: Column[] = [
  { key: "userName", label: "Usuário" },
  { key: "taskType", label: "Tarefa" },
  { key: "microAreaManagementGroupInitials", label: "Grupo Manejo" },
  { key: "status", label: "Status" },
  {
    key: "createdAt",
    label: (
      <div>
        Data
        <br />
        Criação
      </div>
    ),
  },
  {
    key: "convertedAt",
    label: (
      <div>
        Data
        <br />
        Sincronização
      </div>
    ),
  },
];

function formatDateTime(value?: string | null) {
  const date = parseUtcDate(value);
  if (!date || Number.isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const time = new Intl.DateTimeFormat(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(date);

  return `${day}/${month}/${year} - ${time}`;
}

function getTaskTypeName(taskType: string) {
  try {
    const taskTypeEnumObj = JSON.parse(
      localStorage.getItem("TaskTypeEnumObj") || "{}",
    );

    return taskTypeEnumObj[taskType] || taskType;
  } catch (e) {
    return taskType;
  }
}

function getStatusName(status: string) {
  const statusMap: Record<string, string> = {
    SENT: "Enviado",
    PENDING: "Não enviado",
    CONVERTED: "Concluido",
  };

  return statusMap[status] || status;
}

export default function NotificationTable({
  listTable,
  isLoading,
}: NotificationTableProps) {
  const [selectedId, setSelectedId] = useState(0);
  const { selectedOrder, setSelectedOrder, sortAsc, setSortAsc } =
    useTableMonitor();

  useEffect(() => {
    setSelectedOrder("createdAt");
  }, [setSelectedOrder]);

  if (!listTable.length) {
    return isLoading ? (
      <div className="emptyTable_container">
        <Loading visible={true} />
      </div>
    ) : (
      <div className="emptyTable_container">
        <span>Nenhum resultado encontrado.</span>
      </div>
    );
  }

  return (
    <>
      <table className="tableTaskEvaluation" style={{ minWidth: 1100 }}>
        <thead>
          <tr>
            {columns.map(({ key, label }) => (
              <th
                key={key}
                onClick={() => {
                  setSelectedOrder(key);
                  if (selectedOrder !== key) {
                    setSortAsc(false);
                    return;
                  }
                  setSortAsc(!sortAsc);
                }}
              >
                <div className="infoColumn">
                  {label}
                  <ArrowIcon
                    className={`iconSort${sortAsc ? "--asc" : ""}`}
                    style={{
                      display: selectedOrder === key ? "block" : "none",
                    }}
                  />
                </div>
              </th>
            ))}
            <th />
          </tr>
        </thead>
        <tbody>
          {listTable.map((notification) => (
            <tr key={notification.id}>
              <td>{notification.user_name || ""}</td>
              <td>{getTaskTypeName(notification.task_type)}</td>
              <td>{notification.micro_area_management_group_initials || ""}</td>
              <td>{getStatusName(notification.status)}</td>
              <td>{formatDateTime(notification.created_at)}</td>
              <td>{formatDateTime(notification.converted_at)}</td>
              <td className="infoButton">
                <button
                  title="Ver detalhes"
                  style={{
                    display: notification.converted_task_id ? "block" : "none",
                    backgroundColor: "transparent",
                  }}
                >
                  <InfoIcon
                    onClick={() => {
                      if (notification.converted_task_id) {
                        setSelectedId(notification.converted_task_id);
                      }
                    }}
                  />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {isLoading && (
        <div className="tableLoadingOverlay" style={{ minWidth: 1100 }}>
          <div className="lds-ring">
            <div></div>
            <div></div>
          </div>
        </div>
      )}

      <ViewTasks selected={selectedId} setSelectedId={setSelectedId} />
    </>
  );
}
